import defineComponent from 'flight';

function SelectOrInputTextUI() {

    this.defaultAttrs({
        selectSelector: '[data-form-select-select]',
        inputSelector: '[data-input-text]',
        lastValueName: 'lastvalue'
    });

    this._inputChange = function (evt) {
        let $currentInput = $(evt.currentTarget);

        // We need a timeout, since the input's value is not updated immediately on cut/paste events
        window.setTimeout(function () {
            if ($currentInput.data(this.attr.lastValueName) !== $currentInput.val()) {
                this._setInputLastValue($currentInput);
                this._selectReset();
            }
        }.bind(this), 0);
    };

    this._inputReset = function () {
        this._inputs.val('');
        this._setInputLastValue();
    };

    this._selectChange = function () {
        this._inputReset();
    };

    this._selectReset = function () {
        let firstOption = this._select.find('option:first');

        if (!firstOption.prop('selected')) {
            this._select.find('option:first').prop('selected', true);
            this._select.trigger('ui:select-or-input-text:on-select-change');
        }
    };

    this._init = function () {
        this._inputs = this.select('inputSelector');

        this._select = this.select('selectSelector');
        this._setInputLastValue();
    };

    this._setInputLastValue = function ($input) {
        let currentValue = '';
        if ($input) {
            currentValue = $input.val();
            $input.data(this.attr.lastValueName, currentValue);
        } else {
            this._inputs.data(this.attr.lastValueName, currentValue);
        }
    };

    this.after('initialize', function () {
        this.on('change', {
            selectSelector: this._selectChange
        });

        this.on('keyup focusout onpaste paste cut input change', {
            inputSelector: this._inputChange
        });

        this._init();
    });
}

module.exports = defineComponent.component(SelectOrInputTextUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/select-or-input-text-ui.js